import * as Updates from "expo-updates";
import { Platform } from "react-native";

const PROD_URLS = {
  apiUrl: "https://tenantSubdomain.api.fanrally.com/api",
  fileUrl: "https://fanrally.go.fanrally.com/user-files/profile",
  rootUrl: "https://tenantSubdomain.go.fanrally.com",
  localhostApiUrl: "",
};

const DEMO_URLS = {
  apiUrl: "https://tenantSubdomain.demo.api.fanrally.com/api",
  fileUrl: "https://fanrally.demo.fanrally.com/user-files/profile",
  rootUrl: "https://tenantSubdomain.demo.fanrally.com",
  localhostApiUrl: "",
};

const STAGE_URLS = {
  apiUrl: "https://tenantSubdomain.stage.api.fanrally.com/api",
  fileUrl: "https://fanrally.stage.fanrally.com/user-files/profile",
  rootUrl: "https://tenantSubdomain.stage.fanrally.com",
  localhostApiUrl: "",
};

const DEV_URLS = {
  apiUrl: "http://tenantSubdomain.api.fanrallydev.com/api",
  fileUrl: "http://fanrally.go.fanrallydev.com/user-files/profile",
  rootUrl: "http://tenantSubdomain.go.fanrallydev.com:8081",
  // the api url if app is running in localhost
};

function getEnvironment() {
  if (Platform.OS === "web") {
    const host = window.location.host;
    const [_, environment, domain] = host.split(".");

    if (host.includes("localhost") || domain === "fanrallydev") {
      return DEV_URLS;
    } else if (environment === "stage") {
      return STAGE_URLS;
    } else if (environment === "demo") {
      return DEMO_URLS;
    } else {
      return PROD_URLS;
    }
  }

  if (Updates.releaseChannel.startsWith("prod")) {
    // matches prod-v1, prod-v2, prod-v3
    return PROD_URLS;
  } else if (Updates.releaseChannel.startsWith("demo")) {
    // matches demo-v1, demo-v2
    return DEMO_URLS;
  } else if (Updates.releaseChannel.startsWith("stage")) {
    // matches stage-v1, stage-v2
    return STAGE_URLS;
  } else {
    // assume any other release channel is development
    return DEMO_URLS; // dev env settings
  }
}

// Returns true only when running on web at {tenant_subdomain}.demo.fanrally.com
export const isDemo = (() => {
  if (Platform.OS === "web") {
    const [_, environment, domain, tld] = window.location.hostname.split(".");
    return environment === "demo" && domain === "fanrally" && tld === "com";
  }

  return false;
})();

// Returns true if app is running in development environment or stage or demo
export const isDev = (() => {
  // return false;
  if (Platform.OS === "web") {
    const host = window.location.host;
    // brewers.go.fanrallydev.com:8081
    if (host.split(".")[2] === "fanrallydev") {
      return true;
    }
    // brewers.go.fanrally.com => go
    if (host.split(".")[1] === "go") {
      return false;
    }
    // brewers.stage.fanrally.com or brewers.demo.fanrally.com
    return true;
  }

  return !Updates.releaseChannel.startsWith("prod"); // if releaseChannel does not start with 'prod', then isDev is true
})();

export default getEnvironment();
